import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let active = true;
    if (!window.location.pathname.startsWith("/admin")) {
      setUser(false);
      setChecked(true);
      return undefined;
    }
    api
      .get("/admin/me")
      .then((r) => active && setUser(r.data))
      .catch(() => active && setUser(false))
      .finally(() => active && setChecked(true));
    return () => {
      active = false;
    };
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      // La sessione vive nel cookie httpOnly impostato dal backend: nessun token nel browser.
      await api.post("/auth/login", { email, password });
      const me = await api.get("/admin/me");
      setUser(me.data);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: apiError(err, "Credenziali non valide") };
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      console.error("Logout non completato sul server, sessione chiusa localmente", err);
    }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, checked, login, logout }), [user, checked, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAdminAuth() {
  return useContext(AuthContext);
}
